import { css, html } from "lit";
import { when } from "lit-html/directives/when.js";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfProgressCircle = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_progress = "indeterminate";
  }
  /**
   * Normalized progress value between 0 and 100
   */
  get progress() {
    if (this.dsf_progress === "indeterminate") {
      return 50;
    }
    if (this.dsf_progress === "complete") {
      return 100;
    }
    return Math.min(100, Math.max(0, this.dsf_progress));
  }
  render() {
    this.style.setProperty("--dsf-progress", `${this.progress}%`);
    const classes = ["w-16", "h-16", "rounded-full", "flex", "items-center", "justify-center"];
    if (this.dsf_progress === "indeterminate") {
      classes.push("animate-spin");
    }
    if (this.dsf_progress === "complete") {
      classes.push("bg-secondary-300");
    } else {
      classes.push("progress");
    }
    return html`<div class=${concatClasses(classes)}>
      ${when(
      this.dsf_progress === "complete",
      () => html`<dsf-icon class="h-12 w-12 text-neutral-0" dsf_name="Check"></dsf-icon>`
    )}
    </div>`;
  }
};
DsfProgressCircle.styles = [
  ...BaseComponent.styles,
  css`
      .progress {
        background: radial-gradient(closest-side, white calc(64% - 1px), transparent 64% 100%),
          conic-gradient(
            rgb(var(--dsf-color-secondary-300)) var(--dsf-progress),
            rgb(var(--dsf-color-neutral-100)) 0
          );
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfProgressCircle.prototype, "dsf_progress", 2);
DsfProgressCircle = __decorateClass([
  defineElement("dsf-progress-circle")
], DsfProgressCircle);
export {
  DsfProgressCircle
};
